import type { EventEmitter, Provider, Type } from '@angular/core';
import { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import type {
  DataSource,
  LayoutBoardGroupHeader,
  SwimlanesData,
  ViewRecord,
} from '@recruitee/views-types';

export interface LayoutBoardCard<T extends ViewRecord> {
  record: T;
  fieldsVisibilityMap: Record<string, boolean>;
  isSelected: boolean;
  select: EventEmitter<T>;
}

export interface BoardConfig<T extends ViewRecord> {
  groupHeader: Type<LayoutBoardGroupHeader>;
  item: Type<LayoutBoardCard<T>>;
}

export type BoardConfigMap = Partial<Record<DataSource['id'], BoardConfig<ViewRecord>>>;

export interface LayoutBoardPublicService {
  swimlanesData$: Observable<SwimlanesData>;
}

export const BOARD_CONFIGS = new InjectionToken<BoardConfigMap>('TABLE_CONFIGS');
export const LAYOUT_BOARD_SERVICE = new InjectionToken<LayoutBoardPublicService>(
  'LAYOUT_BOARD_SERVICE',
);

export const provideBoardLayout = (boardConfigMap: BoardConfigMap): Provider[] => [
  {
    provide: BOARD_CONFIGS,
    useValue: boardConfigMap,
  },
];
